import React from 'react';
import styled from 'styled-components';
import { components } from 'react-select';

const INDENT_PADDING = 20; // padding for the hierarchy depth

const AliasNameSpan = styled('div')`
    color: ${props => (props.isSelected ? '#FFF' : props.theme.colors.bluemine)};
    font-size: 10px;
    padding: 0;
    margin: 0;

`;

const LabelSpan = styled('div')`
    color: ${props => (props.isSelected ? '#FFF' : props.theme.colors.black)};
    font-size: 13px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0;

`;

const HierarchyIconWrap = styled('div')`
    color: #C4C4C4; 
    float: left;
    height: 100%;
    padding: 0 5px 0 0;
`;

const ValueWrapper = styled('div')`
    display: flex;
    align-content: center;
    justify-content: flex-start;
    flex-direction: column;
`;

const EntityDropdownOption = props => (
    <components.Option {...props}>
        <div style={{ minHeight: '48px', maxHeight: '48px', display: 'flex', alignItems: 'center' }} >
            <div>
                {props.data.depth > 0 && (
                    <HierarchyIconWrap style={{ paddingLeft: `${props.data.depth * INDENT_PADDING}px` }} className="icon-hierarchy" />
                )
                }
                <ValueWrapper>
                    <LabelSpan isSelected={props.isSelected}>{props.label}</LabelSpan>
                    <AliasNameSpan isSelected={props.isSelected}>{props.data.aliasName}</AliasNameSpan>
                </ValueWrapper>
            </div>
        </div>
    </components.Option>
);

export default EntityDropdownOption;



// WEBPACK FOOTER //
// ./src/components/molecules/EntityDropdownOption.js